export const getmarketStockExchange = (state) => state.marketStockExchange.data;

export const getWebAreas = (state) => state.marketStockExchange.webAreas;

export const getCurrentWebAreas = (state) =>
  state.marketStockExchange.tabWebAreaId;

export const getSelectedTitle = (state) =>
  state.marketStockExchange.selectedTitle;

export const getIsLoading = (state) => state.marketStockExchange.isLoading;

export const getCurrentStockExchangeTab = (state) =>
  state.marketStockExchange.currentTab;
